import React, { useRef } from 'react';
import './Download.css';
import PlainHeader from '../../components/PlainHeader/PlainHeader';
// import GooglePlay from '../../assets/images/google-play-badge.png'
import DeviceImage from '../../assets/images/home1.png';
import WindowsFile from '../../assets/downloads/No Wires_0.1.0_x64.msi';
import AndroidFile from '../../assets/downloads/nowires.apk';
import Snackbar from "../../components/Snackbar/Snackbar";

const SnackbarType = {
    success: "success",
    fail: "fail",
};

const Download = () => {

    const snackbarRef = useRef(null);
    return (
        <div>
            <PlainHeader />
            <div className="downloadContainer">
                <div className="downloadList ">
                    <div className="downloadItem" >
                        <div className="downloadCard">
                            <h5>Android</h5>
                            <p className="desc__1dLZK">Install No Wires on your phone and desktop version.</p>
                            <div className="deviceImage">
                                <img src={DeviceImage} alt="android phone" width="200px" height="144px" />
                            </div>

                            <a href={AndroidFile} className="downloadButton" download="NoWires.apk">
                                Download
                            </a>
                            {/* <a href='https://play.google.com/store/apps/details?id=me.jayanthsaikiran.nowires&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank" rel="noreferrer">
                                <img src={GooglePlay} alt="playstore link" width="196px" height="56px" style={{ marginTop: "1.25rem", cursor: 'pointer' }} />
                            </a> */}
                        </div>
                    </div>
                    <div className="downloadItem">
                        <div className="downloadCard">
                            <h5>Windows</h5>
                            <p className="desc__1dLZK">Install No Wires on your windows and scan QR from your phone(No Wires app).</p>
                            <div className="deviceImage">
                                <img src={DeviceImage} alt="windows laptop" width="200px" height="144px" />
                            </div>

                            <a href={WindowsFile} className="downloadButton" download="No Wires_0.1.0_x64.msi">
                                Download
                            </a>
                            {/* <div className="downloadButton" >Download</div> */}

                        </div>
                    </div>
                    <div className="downloadItem">
                        <div className="downloadCard">
                            <h5>Mac Os</h5>
                            <p className="desc__1dLZK">Install No Wires on your Mac machine and scan QR from your phone(No Wires app).</p>
                            <div className="deviceImage">
                                <img src={DeviceImage} alt="macbook" width="200px" height="144px" />
                            </div>
                            {/* <a href={WindowsFile} className="downloadButton" download="No Wires_0.1.0_x64.msi">
                                Download
                            </a> */}
                            <div className="downloadButton" onClick={() => {
                                snackbarRef.current.show();
                            }}>Download</div>

                        </div>
                    </div>

                    <div className="downloadItem">
                        <div className="downloadCard">
                            <h5>Ubuntu</h5>
                            <p className="desc__1dLZK">Install No Wires on your ubuntu system and scan QR from your phone(No Wires app).</p>
                            <div className="deviceImage">
                                <img src={DeviceImage} alt="ubuntu laptop" width="200px" height="144px" />
                            </div>

                            {/* <a href={WindowsFile} className="downloadButton" download="No Wires_0.1.0_x64.msi">
                                Download
                            </a> */}
                            <div className="downloadButton" onClick={() => {
                                snackbarRef.current.show();
                            }}>Download</div>                        </div>
                    </div>
                </div>
                <Snackbar
                    ref={snackbarRef}
                    message="Coming Soon!"
                    type={SnackbarType.success}
                />
            </div>


        </div>
    )
}

export default Download;